import { getI18n } from 'src/i18n/i18n.middleware'
import { dynamic } from 'src/utils/ssr'
import { staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/generator.preset._index'

const getClientModule = () => import('src/clientRoutes/generator.preset._index')

export const handle = {
  name: 'generator/preset',
  track: { scene: 'ai-tools-landing' },
  showAppNav: true,
}

const OG_IMAGE =
  'https://images-ng.pixai.art/images/thumb/cd55ae1f-ddf4-42e9-9cd7-99dcdb79c4a8'

/** SSR loader. Source: https://github.com/troph-team/pixai/blob/main/packages/pixai-server/src/ssr/router.ts#L382-L393 */
export function loader({ request, context }: Route.LoaderArgs) {
  const { t } = getI18n(context)
  return staticMetaLoader({
    requestUrl: request.url,
    title: t('server:meta.tools-landing.title'),
    description: t('server:meta.tools-landing.description'),
    image: OG_IMAGE,
  })
}

/** Meta function for SSR SEO. */
export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export default dynamic(getClientModule, { ssr: false })
